import { ControlledTextField } from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

export const FormContent = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();
  return (
    <>
      <ControlledTextField
        name="push_appKey"
        label={t('pushNotifications.app_key_title')}
        control={control}
      />
      <ControlledTextField
        name="push_productKey"
        label={t('pushNotifications.product_key_title')}
        control={control}
      />
      <ControlledTextField
        disabled
        name="push_allowedChannels"
        label={t('pushNotifications.allowed_channels')}
        control={control}
      />
    </>
  );
};
